import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { Subscription } from 'rxjs'
import { SharedService } from 'src/app/shared/services/shared.service'
import { PointingCheckpoint } from '../../models/pointing-system.enums'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-points-filter',
	templateUrl: './points-filter.component.html',
	styleUrl: './points-filter.component.scss',
})
export class PointsFilterComponent {
	@Output() emitFilter = new EventEmitter()
	@Output() emitfilterCount = new EventEmitter()
	@Input() pointsFilter: any = {
		countryId: 224,
		activeTab: 1,
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		startDate: '',
		endDate: '',
		pointingCheckpoint: '',
	}
	subscription = new Subscription()
	filterForm: FormGroup = new FormGroup({})
	filterCount = 0
	pointingActions = this.SharedService.returnEnumArray(PointingCheckpoint)
	constructor(
		private SharedService: SharedService,
		public translate: TranslateService
	) {}
	ngOnInit(): void {
		this.initForm()
		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0

			for (let value in val) {
				if (
					(this.getController(value).value ||
						this.getController(value).value == 0) &&
					this.getController(value).value != false
				)
					this.filterCount += 1
			}
		})
	}
	initForm() {
		this.filterForm = new FormGroup({
			startDate: new FormControl(this.pointsFilter.startDate || null),
			endDate: new FormControl(this.pointsFilter.endDate || null),
			pointingCheckpoint: new FormControl(
				this.pointsFilter.pointingCheckpoint || null
			),
		})
	}
	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName] as FormControl
	}
	resetFilter() {
		this.filterForm.reset()
		this.pointsFilter = {
			...this.pointsFilter,
			...this.filterForm.getRawValue(),
		}
		this.getController('includeActive')
		this.emitFilter.emit(this.pointsFilter)
		this.emitfilterCount.emit(this.filterCount)
	}

	submit() {
		this.pointsFilter = {
			...this.pointsFilter,
			...this.filterForm.getRawValue(),
		}
		console.log(this.pointsFilter)

		this.emitFilter.emit(this.pointsFilter)
		this.emitfilterCount.emit(this.filterCount)
	}
}
